import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.LeaseStorableItems1,
  LocationVarKey.LeaseStorableItems2,
  LocationVarKey.LeaseStorableItems3
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Storable Items
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.LeaseStorableItems1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.LeaseStorableItems2}
        enableSwitchVar={LocationVarKey.LeaseStorableItems2Enabled}
      />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.LeaseStorableItems3}
        enableSwitchVar={LocationVarKey.LeaseStorableItems3Enabled}
      />
    </>
  );
}
